import { merge } from 'lodash-es'

import { MarketShareAPI } from 'src/api'

import competitor from './competitor'

const salesModule = {
  namespaced: true,
  actions: {
    issetData(_, data) {
      return data.isActualPeriod || data.actualPeriod !== undefined || data.dealership !== undefined
    },
    async reportUpload({ getters }, { file, onUploadProgress, id = 0 }) {
      let { dealerShipId } = getters.settingsParams
      if (+dealerShipId === 0) {
        dealerShipId = id
      }
      const data = await MarketShareAPI.reportUpload({
        onUploadProgress,
        file,
        dealerShipId: id,
      })

      return data
    },
  },
  getters: {
    settingsParams(state, getters, { settings }) {
      const { dealerGroupId, dealerShipId, year, viewType, month, quarter } = settings
      const params = {
        dealerGroupId,
        dealerShipId,
        year,
      }
      switch (viewType) {
        case 'daysOfMonth':
          params.month = month
          params.view = 'month'
          break
        case 'monthsOfQuarter':
          params.quarter = quarter
          params.view = 'quarter'
          break
        case 'monthsOfYear':
          params.view = 'year'
          break
      }
      return params
    },
  },
}

export default merge({ ...salesModule }, competitor)
